import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ApiMethod } from '../apimethods/api-method';
import { GlobalConstants } from '../common/global-constants';
declare var $;
import { DomSanitizer } from "@angular/platform-browser";
import { ArticleinfoComponent } from '../articleinfo/articleinfo.component';

@Component({
  selector: 'app-quick-search',
  templateUrl: './quick-search.component.html',
  styleUrls: ['./quick-search.component.css'],
  encapsulation: ViewEncapsulation.Emulated
})
/** quick-search component*/
export class QuickSearchComponent implements OnInit {
  showModal: boolean;
  constructor(private sanitizer: DomSanitizer) { }

  transform(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  ngOnInit() {
    $('#divitemList').css('height', GlobalConstants.size.height - 100);
    QuickSearchComponent.loadSearchDataList();
  }

  public static loadSearchDataList() {
    let dataEmpty = '<h3 style="height: 100px; line-height: 100px; text-align: center;"> No data found !</h3>';
    if ($('#txtQuickSearch').val().trim() == '') {
      $('#divitemList').html(dataEmpty);
    }
    else {
      $("#LoadingImage").show();
      var dataitem = {
        FilterText: $('#txtQuickSearch').val(),
        LoginId: localStorage.aLoginID,
        PublisherId: localStorage.aPubID
      };
      ApiMethod.postMethod("api/searchresult", dataitem).subscribe(
        resonse => {

          let itemList = resonse.aitemList;

          var zTableList = '<div class="DivList"><table width="100%">';
          let artId = 0;
          $.each(itemList, function (e, val) {
            if (artId != val.ID) {

              artId = val.ID;
              zTableList += '<tr style="background-color: #e6e9ff;cursor:pointer;border-bottom: #888888 2px solid;" data-id="' + val.ID + '" onclick=localStorage.aEID="' + val.ID + '";$("#btnPopupDT").trigger("click");>';

              zTableList += '<td>';
              zTableList += '<div class="row divDataItem" style="padding: 8px;">';
              zTableList += '<div class="col-sm-12 child"><strong>' + 'Title : ' + val.ArticleTitle + '</strong></div>';
              zTableList += '<div class="col-sm-4 divPadd">' + 'ArticleNo : ' + val.ArticleNo + '</div>';
              zTableList += '<div class="col-sm-8 divPadd">' + 'Doi : ' + val.DOI + '</div>';
              zTableList += '<div class="col-sm-4 divPadd">' + 'Receive Date : ' + GlobalConstants.FormatDate(val.ReceivedDate) + '</div>';
              zTableList += '<div class="col-sm-4 divPadd">' + 'Type : ' + val.ArticleType + '</div>';
              zTableList += '<div class="col-sm-4 divPadd">' + 'Volume-Issue : ' + val.Volume + '-' + val.Issue + '</div>';
              zTableList += '<div class="col-sm-4 divPadd">' + 'Author Name : ' + GlobalConstants.isNullCheck(val.Authors) + '</div>';
              if (GlobalConstants.isNullCheck(val.ConversionfromNT) != "") {
                zTableList += '<div class="col-sm-4 divPadd">' + 'Conversion : ' + GlobalConstants.isNullCheck(val.ConversionfromNT) + '</div>';
              }
              if (GlobalConstants.isNullCheck(val.SenttoVendor) != "") {
                zTableList += '<div class="col-sm-4 divPadd">' + 'Vendor : ' + GlobalConstants.isNullCheck(val.SenttoVendor) + '</div>';
              }
              if (GlobalConstants.isNullCheck(val.QCfromNT) != "") {
                zTableList += '<div class="col-sm-4 divPadd">' + 'QC : ' + GlobalConstants.isNullCheck(val.QCfromNT) + '</div>';
              }

              zTableList += '</td></tr>';


            }
          });
          zTableList += '</table></div>';

          if (itemList.length == 0) {
            zTableList = dataEmpty;
          }
          $('#divitemList').html(zTableList);
          $("#LoadingImage").hide();
        },
        error => {
          console.error(error)
          $("#LoadingImage").hide();
        }
      );
    }
  }

  show() {
    $('#btnPopupartMeta').trigger('click');
  }

}
